import { g as o } from "./global.js";
import { f as e } from "./fails.js";
import { e as r } from "./engine-webkit-version.js";
var t = !e(function () {
  if (!r || !(r < 535)) {
    var e = Math.random();
    __defineSetter__.call(null, e, function () {}), delete o[e];
  }
});
export { t as o };